<div class="card">
  <div class="flex justify-between items-center mb-3">
    <h3 class="font-semibold text-base">Updates</h3>
  </div>
  <div class="mb-3">
    <textarea class="text-box w-full" rows="3" [(ngModel)]="newUpdateText" placeholder="Add an update..." [ngClass]="{'p-invalid': warn}"></textarea>
    @if (warn) {
      <p class="text-danger-base text-sm mt-1">Please enter an update.</p>
    }
    <div class="flex justify-end mt-2">
      <button class="btn-primary btn-small" type="button" [disabled]="saving" (click)="submit()">
        <i class="pi" [ngClass]="saving ? 'pi-spin pi-spinner' : 'pi-plus'"></i>
        <span class="ml-1 text-sm">{{saving ? 'Saving...' : 'Add Update'}}</span>
      </button>
    </div>
    @if (errorMessage && errorMessage.length>0) {
      <p class="text-danger-base text-sm mt-1">{{errorMessage}}</p>
    }
  </div>
  <div class="flex flex-col gap-3">
    @for (u of pagedUpdates; track u) {
      <div class="update">
        <p class="font-semibold">{{u.User}}</p>
        <p class="text-sm text-grey-800">{{u.Note}}</p>
        <p class="text-xs text-grey-600">{{u.Date | date:'dd MMM yyyy, HH:mm'}}</p>
      </div>
    }
    @if (updates.length === 0) {
      <p class="text-grey-500 text-sm">No updates yet.</p>
    }
  </div>
  @if (updates.length >= 5) {
    <div class="paginator-wrapper">
      <p-paginator
        [rows]="pageSize"
        [totalRecords]="updates.length"
        [rowsPerPageOptions]="[5,10,20]"
        [pageLinkSize]="3"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  }
</div>
